<template>
  <b-form class="step-form" @submit.stop.prevent="onSubmit">
    <div class="row">
      <div class="col-lg-12">
        <h3>Step 2: Record Video</h3>
        <p class="info">
          <i class="icon-error_outline"></i>If you are wearing glasses, please remove them before recording your video.
        </p>
        <div
          id="web_player"
          ref="printMe3"
          class="video-record"
          :class="
                        showVideo == true
                            ? 'videoRecored'
                            : '' || timeShow == true
                            ? 'videoRecored'
                            : ''
                    "
        >
          <div id="container_row" class="container_row">        
            <img
              id="thumbnail_img"
              src="data:image/gif;base64,R0lGODlhAQABAAD/ACwAAAAAAQABAAACADs="
              class="thumbnail_img"
            ></img>
            <img
              id="cam_error"
              class="cam_error"
              :src="require('@/assets/cam_error.jpg')"
            />
            <img
              id="cam_error_phone"
              class="cam_error_phone"
              :src="require('@/assets/cam_error_phone.jpg')"
            />
            <div id="show-record-video" class="show-record-video">
              <video-js-record
                ref="camera1"
                crossorigin="anonymous"
                @recordingStarted="onVideoRecording"
                @recordingEnded="onRecordingEnded"
              ></video-js-record>
            </div>

            <div id="action-label" class="layer1">
              <!--                        <mark id="action-label"> </mark>-->
            </div>
            <div id="anim_layer" class="anim_layer">
              <div id="layer2" class="layer2">
                <img
                  id="face_outline"
                  :src="require('@/assets/face-outline.png')"
                  style="width: auto; height: auto"
                />
              </div>
              <div id="arrows" class="arrow">
                <span></span>
                <span></span>
                <span></span>
              </div>
              <div id="smiley" class="smiley">
                <div class="eyes">
                  <div class="eye"></div>
                  <div class="eye"></div>
                </div>
                <div class="mouth"></div>
              </div>
            </div>
          </div>
          <div
            id="video-play"
            :class="showVideo == true ? 'video-recorded' : ''"
            class="video-play"
          >
                        <span v-if="timeShow" class="timer-countdown">{{
                            countDown
                          }}</span>
            <i class="icon-record">
              <i class="path1"></i>
              <i class="path2"></i>
              <i class="path3"></i>
            </i>
            <p v-if="showVideo == false" id="record-label">Start</p>
            <p v-if="showVideo == true">Finish</p>
          </div>
        </div>
        <canvas
          id="frame-canvas"
          ref="canvas"
          class="frame-canvas-c"
          :width="500"
          :height="375"
        ></canvas>

        <base-button
          btn-type="submit"
          btn-variant="primary"
          btn-label="CONTINUE"
          :class="loading ? 'disabled' : ''"
          :disabled="loading || !livenessStatus || countDown > 0"
        ></base-button>
      </div>
    </div>
    <!--        <div>-->
    <!--            <button @click="checkCamera">{{ 'Check Camera' }}</button>-->
    <!--        </div>-->
    <!--      <div>-->
    <!--        <button @click="checkAudio">{{ 'Check Audio' }}</button>-->
    <!--      </div>-->
    <div id="intro_anim">
      <h1 class="block-effect" style="--td: 1.5s">
        <div class="block-reveal" style="--bc: #9f40bf; --d: 0.1s">
          <img
            id="idenfo_logo"
            :src="require('@/assets/idenfo.jpeg')"
            style="width: auto; max-width: 90%; height: auto"
          />
        </div>
        <div
          class="block-reveal"
          style="
                        --bc: #40aabf;
                        --d: 0.5s;
                        text-align: right;
                        padding-right: 15%;
                        font-family: 'LucidaHandwriting-Italic';
                    "
        >
          Liveness
        </div>
      </h1>
    </div>
  </b-form>
</template>
<script>
import { mapGetters } from 'vuex'
import request from '@/utils/request'
import _ from 'lodash'
import resource from '@/api/resource'
const modulesApi = new resource('configurations/modules')

//import IdentityType from '@/components/registration/IdentityType.vue'
// import IdentityDocument from '@/components/registration/IdentityDocument.vue'
//import UtilityBill from '@/components/registration/UtilityBill.vue'
//import Cropper from '@/components/registration/Cropper.vue'
// import Signature from '@/components/registration/Signature.vue'
//import resource from '@/api/resource'
import videoJsRecord from '@/components/VideoJSRecord.vue'
//import html2canvas from 'html2canvas'

//const viewBrandingApi = new resource('configurations/branding')
/* eslint-disable */
export default {
    /*
|--------------------------------------------------------------------------
| Component > components
|--------------------------------------------------------------------------
*/

    // sockets: {
    //   connect() {
    //     console.log('socket connected')
    //   },
    // },
    components: {
        videoJsRecord,

        // Signature,
        // Disclaimer,
        // VueCroppie,
    }, // End of Component > components

    /*
|--------------------------------------------------------------------------
| Component > props
|--------------------------------------------------------------------------
*/
    props: {}, // End of Component > props

    /*
|--------------------------------------------------------------------------
| Component > data
|--------------------------------------------------------------------------
*/
    data() {
        return {
            liveness: null,
            nameScreening: null,
            username: 'Talal',
            audio: {
                correct: 0,
                smile: 1,
                'turn face left': 2,
                'turn face right': 3,
                blink: 4,
                passed: 5,
                failed: 6,
            },
            countDown: 20,
            showVideo: false,
            timeShow: false,
            recordingStart: false,
            cameraReady: false,
            readyState: -1,
            recordingEnded: false,
            cameraActive: false,
            introAnimEnded: false,
            activeQuestion: '',
            previousQuestion: '',
            orientationTimer: 0,
            frameCount: 0,
            soundeffect: '',
            frameCountServer: -1,
            livenessStatus: false,
            livenessCount: 0,
            animCount: 0,
            connectionCount: 0,
            ping_count: 0,
            animMapping: {
                smile: 'smiley',
                'turn face right': 'arrow',
                'turn face left': 'arrow',
                face_outline: 'layer2',
                blink: 'smiley',
                0: 'none',
                1: 'block',
                2: 'flex',
                'action-label': 'action-label',
                layer1: 'layer1',
            },
            frameLag: 0,
        }
    }, // End of Component > data

    /*
|--------------------------------------------------------------------------
| Component > computed
|--------------------------------------------------------------------------
*/
    computed: {
        ...mapGetters(['dataSegmentId', 'loading']),

        // ...mapState({
        //     userOcr: (state) => state.registration.useOcr,
        // }),
        //
        // ...mapGetters(['dataSegmentId', 'loading', 'form']),
        //
        dataSegmentId() {
            if (this.$route.params.dataSegmentId) {
                return this.$route.params.dataSegmentId
            }
            return this.$store.getters.dataSegmentId
        },
    }, // End of Component > computed

    /*
|--------------------------------------------------------------------------
| Component > watch
|--------------------------------------------------------------------------
*/

    watch: {
        // setInterval(() => {
        //
        //   if (this.timeShow === true){
        //         console.log('Recording video ... ')
        //     }
        // }, 1000)
        /**
         * Handle when the file is uploaded successfully
         *
         * @return {void}
         */
        // End of user() method
    }, // End of Component > methods

    created() {
        this.$root.$refs.A = this
        this.$socket.client.connect()
    },

    /*
|--------------------------------------------------------------------------
| Component > mounted
|--------------------------------------------------------------------------
*/
    mounted() {
        this.getModuleData()

        let soundEffect = this.$store.getters.getField('soundSrc')
        console.log(window.navigator.userAgent)
        var cond =
            'non ipad device:' +
            this.detectMob() +
            ' Ipad device' +
            this.isIpadOS()
        console.log(cond)

        this.soundeffect = soundEffect
        this.soundeffect.autoplay = true
        console.log('DEVICE TYPE:', this.detectMob())
        console.log('IPAD:', this.isIpadOS())
        this.$store.commit('updateField', {
            key: 'isIphone',
            value: this.detectMob(),
        })
        if (this.detectMob() == false) {
            if (this.isIpadOS() != true) {
                var ipad = false
            } else {
                var ipad = true
            }
            this.$store.commit('updateField', {
                key: 'isIphone',
                value: ipad,
            })
        }
        console.log('dataSegmentId:', this.$route.params.dataSegmentId)
        //this.$refs.canvas.style.display = 'none'
        this.startIntroAnimation()
        // window.addEventListener("orientationchange", ()=> {
        //   alert('Orientation: ', screen.orientation.angle, window.orientation)
        //   this.setContent();
        // });

        window.addEventListener('resize', this.setContent)

        // this.loadAudio();

        //
        // $("face_outline").on('click', function(e) {
        //   this.soundeffect.src = (this.audio['correct']).src
        //   alert('cat')
        //   console.log('clicketttt')
        // });

        // document.getElementsByClassName("icon-record")[0]
        //   .addEventListener('click', function (event) {
        //     // this.soundeffect.src = (this.audio['correct']).src
        //     alert('cat')
        //     console.log('clicketttt')
        //   });

        // document.getElementsByClassName('video-record')[0]
        //   .addEventListener('click', function (event) {
        //     alert('Clicked');
        //     console.log('clicketttt')
        //   });
        // this.checkCam();
        // this.loadImageCam();
        // this.check_ping(this.ping_count);
        //this.initializeSecondaryCam();

        //
        // this.getBrandingData()
        // this.$store.commit('initDefaultFields', 'form')
    }, // End of Component > watch

    /*
|--------------------------------------------------------------------------
| Component > methods
|--------------------------------------------------------------------------
*/

    beforeDestroy() {
        console.log('unmounted')
        this.$socket.client.disconnect()
    },
    methods: {
        /**
         * Handle when the form has been submitted
         *
         * @return {void}
         */
        async getModuleData() {
            try {
                if (this.dataSegmentId) {
                    let { data } = await modulesApi.list({
                        dataSegmentId: this.dataSegmentId,
                    })
                    if (!_.isEmpty(data.data)) {
                        console.log('Record Video Page', data.data)
                        this.liveness = data.data.liveness
                        this.nameScreening = data.data.nameScreening
                      if (this.liveness == false || this.$store.getters.form.type=='company') {
                        this.$router.push({name: 'deep-registration-setup-profile',params:{source:this.$route.params.source}})
                      }
                    }
                }
            } catch (error) {
                console.log('MODULE DATA ERROR', error)
            }
        },
        checkAudio() {
            this.soundeffect.src = this.audio['smile'].src
        },
        detectMob() {
            const toMatch = [/iPhone/i, /iPad/i, /iPod/i]

            return toMatch.some((toMatchItem) => {
                return navigator.userAgent.match(toMatchItem)
            })
        },
        isIpadOS() {
            return (
                navigator.maxTouchPoints &&
                navigator.maxTouchPoints > 2 &&
                /MacIntel/.test(navigator.platform)
            )
        },
        checkCamera() {
            // this.$root.$refs.B.checkCamera();
            //console.log('Img: ', document.getElementById("cam_error").clientWidth, document.getElementById("cam_error").clientHeight)
            // let width = document.getElementById("container_row").clientWidth
            // let height = document.getElementById("container_row").clientHeight
            // var startDate = new Date();
            // let len = 4000000
            // let load = new Array(len + 1).join('x');
            // this.$socket.client.emit('test_connection', [load ,this.connectionCount])
            // this.$socket.client.on('test_connection', (data) => {
            //   this.$socket.client.off('test_connection');
            //
            //   var endDate = new Date();
            //   var seconds = (endDate.getTime() - startDate.getTime()) / 1000;
            //   console.log(data, 'Connection Lag (s): ', seconds)
            //   this.connectionCount = this.connectionCount + 1
            // })
        },
        toggleCamera(status) {
            let img_id = this.selectCamErrorImage(this.getAspectRatio())
            if (status && this.introAnimEnded) {
                document.getElementById(img_id[0]).style.display = 'none'
                document.getElementById(img_id[1]).style.display = 'none'
                document.getElementById('anim_layer').style.visibility =
                    'visible'
                document.getElementById('video-play').style.visibility =
                    'visible'
            } else if (status === false && this.introAnimEnded) {
                document.getElementById('anim_layer').style.visibility =
                    'hidden'
                document.getElementById('video-play').style.visibility =
                    'hidden'
                document.getElementById(img_id[0]).width =
                    document.getElementById('container_row').clientWidth
                document.getElementById(img_id[0]).height =
                    document.getElementById('container_row').clientHeight
                document.getElementById(img_id[1]).style.display = 'none'
                document.getElementById(img_id[0]).style.display = 'inline'
            }
            this.cameraActive = status
            console.log('Camera Status: ', this.cameraActive)
        },

        selectCamErrorImage(ar) {
            let img,
                img2 = ''
            if (ar >= 1) {
                img = 'cam_error'
                img2 = 'cam_error_phone'
            } else {
                img = 'cam_error_phone'
                img2 = 'cam_error'
            }
            return [img, img2]
        },
        getAspectRatio() {
            let width = document.getElementById('container_row').clientWidth
            let height = document.getElementById('container_row').clientHeight
            let ar = width / height
            return ar
        },
        setContent() {
            if (this.livenessStatus !== true) {
                setTimeout(() => {
                    console.log('Orientation: ', window.orientation)
                    let width =
                        document.getElementById('show-record-video').clientWidth
                    let height =
                        document.getElementById(
                            'show-record-video'
                        ).clientHeight
                    let ar = width / height

                    let log = [
                        'Width: ',
                        width,
                        ', Height: ',
                        height,
                        ', AR: ',
                        ar,
                        ', Orientation: ',
                        window.orientation,
                    ]

                    let log_str = log.join('')

                    console.log(log_str)

                    if (ar < 1) {
                        document.getElementById('face_outline').style.maxWidth =
                            '60%'
                        document.getElementById('layer2').style.top = '20%'
                    } else {
                        document.getElementById('face_outline').style.maxWidth =
                            '35%'
                        document.getElementById('layer2').style.top = '25%'
                    }
                }, this.orientationTimer)
            }
        },
        check_ping(pc) {
            let ping_start = new Date()
            this.$socket.client.emit('test', {
                ping_start: ping_start.getTime(),
                pc: pc,
            })
            this.$socket.client.on('response_back', (data) => {
                this.$socket.client.off('response_back')
                var endDate = new Date()
                var seconds = endDate.getTime() - data['ping_start']
                console.log(
                    'Ping Count: ',
                    data['pc'],
                    ', Ping: ',
                    seconds,
                    ' ms'
                )
                console.log(
                    'Ready State: -> ',
                    this.$refs.camera1.$refs.video_ref.readyState
                )
            })

            setTimeout(() => {
                this.ping_count = this.ping_count + 1
                this.check_ping(this.ping_count)
            }, 1000)
        },

        startIntroAnimation() {
            document.getElementById('web_player').style.visibility = 'hidden'
            document.getElementById('idenfo_logo').style.visibility = 'hidden'
            let element = document.getElementById('intro_anim')
            element.addEventListener(
                'webkitAnimationEnd',
                this.showVideoFeed,
                false
            )
        },

        loadAudio() {
            //this.soundeffect = new Audio()
            //this.soundeffect.autoplay = true
            this.audio['correct'] = new Audio(
                require('@/assets/sounds/correct.mp3')
            )
            this.audio['smile'] = new Audio(
                require('@/assets/sounds/smile.mp3')
            )
            this.audio['turn face left'] = new Audio(
                require('@/assets/sounds/turn-left.mp3')
            )
            this.audio['turn face right'] = new Audio(
                require('@/assets/sounds/turn-right.mp3')
            )
            this.audio['blink'] = new Audio(
                require('@/assets/sounds/blink-eyes.mp3')
            )
            // this.audio[4] = new Audio(require('@/assets/sounds/close-eyes.mp3'));
            this.audio['passed'] = new Audio(
                require('@/assets/sounds/liveness-passed.mp3')
            )
            this.audio['failed'] = new Audio(
                require('@/assets/sounds/liveness-failed.mp3')
            )

            //let ua = navigator.userAgent
            //let event =
            //    ua.match(/iPad/i) || ua.match(/iPhone/) ? 'touchstart' : 'click'
            //console.log('click specs: ', ua, event)

            //for (let item of document.querySelectorAll('.video-record')) {
            //    item.addEventListener(event, this.soundListener, false)
            //}
        },
        soundListener() {
            const sound =
                'data:audio/mpeg;base64,SUQzBAAAAAABEVRYWFgAAAAtAAADY29tbWVudABCaWdTb3VuZEJhbmsuY29tIC8gTGFTb25vdGhlcXVlLm9yZwBURU5DAAAAHQAAA1N3aXRjaCBQbHVzIMKpIE5DSCBTb2Z0d2FyZQBUSVQyAAAABgAAAzIyMzUAVFNTRQAAAA8AAANMYXZmNTcuODMuMTAwAAAAAAAAAAAAAAD/80DEAAAAA0gAAAAATEFNRTMuMTAwVVVVVVVVVVVVVUxBTUUzLjEwMFVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVf/zQsRbAAADSAAAAABVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVf/zQMSkAAADSAAAAABVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVV'
            this.soundeffect.src = sound
            alert('Sound Initialized!')
            this.removeSoundListener()
        },
        playAudio(action) {
            this.soundeffect.src = this.audio[action].src
        },
        removeSoundListener() {
            let ua = navigator.userAgent
            let event =
                ua.match(/iPad/i) || ua.match(/iPhone/) ? 'touchstart' : 'click'
            for (let item of document.querySelectorAll('.video-record')) {
                item.removeEventListener(event, this.soundListener)
            }
        },

        showVideoFeed() {
            if (this.animCount === 6) {
                this.setContent()
                document.getElementById('intro_anim').style.display = 'none'
                document.getElementById('web_player').style.visibility =
                    'visible'
                //this.setLabel('Align your head and press start');
                this.setLabel('Align your head')
                //document.getElementById("action-label").innerHTML = 'Align your head and press start';
                document
                    .getElementById('intro_anim')
                    .removeEventListener(
                        'webkitAnimationEnd',
                        this.showVideoFeed
                    )
                this.introAnimEnded = true
                this.orientationTimer = 500
                console.log('Animation Ended: ', this.animCount)
                this.loadAudio()
            } else {
                if (this.animCount === 1) {
                    document.getElementById('idenfo_logo').style.visibility =
                        'visible'
                }
                console.log('Animation End Count: ', this.animCount)
                this.animCount += 1
            }
        },
        setLabel(label) {
            document.getElementById('action-label').innerHTML = label
        },
        async onSubmit() {
            if (this.livenessStatus == true) {
                let verificationStatus = {
                    liveness: {
                        score: 100,
                        result: 'Real',
                        isManual: false,
                        createdAt: new Date(),
                    },
                    face: null,
                }

                this.$store.commit('updateField', {
                    key: 'verificationStatus',
                    value: verificationStatus,
                })
            }
            if (this.$route.meta.publicRegistration === true) {
                this.$router.push({
                    name: 'deep-registration-setup-profile',
                    params: {
                        dataSegmentId: this.$route.params.dataSegmentId,
                        token: this.$route.params.token,
                        source:this.$route.params.source
                    },
                })
            } else {
                this.$router.push('/register-customer/setup-profile')
            }
        },

        toggleAnimation(name, visibility) {
            console.log(
                'Animation: ',
                name,
                this.animMapping[name],
                this.animMapping[visibility]
            )

            if (this.previousQuestion !== '') {
                document.getElementsByClassName(
                    this.animMapping[this.previousQuestion]
                )[0].style.display = this.animMapping[0]
            }
            if (name === 'turn face left') {
                document.getElementsByClassName(
                    this.animMapping[name]
                )[0].style.left = '15%'
                document.getElementsByClassName(
                    this.animMapping[name]
                )[0].style.transform = 'rotate(90deg)'
            } else if (name === 'turn face right') {
                document.getElementsByClassName(
                    this.animMapping[name]
                )[0].style.left = '80%'
                document.getElementsByClassName(
                    this.animMapping[name]
                )[0].style.transform = 'rotate(-90deg)'
            } else if (name === 'blink') {
                document.getElementsByClassName('eye')[0].style.animation =
                    'wink 1s infinite'
                document.getElementsByClassName('eye')[1].style.animation =
                    'wink 1s infinite'
                document.getElementsByClassName(
                    'eyes'
                )[0].style.animationPlayState = 'paused'
                document.getElementsByClassName(
                    'mouth'
                )[0].style.animationPlayState = 'paused'
                document.getElementsByClassName('mouth')[0].style.height = '5%'
                document.getElementsByClassName('mouth')[0].style.width = '40%'
                document.getElementsByClassName('mouth')[0].style.bottom = '25%'
                document.getElementsByClassName('mouth')[0].style.marginLeft =
                    '-20%'
            } else if (name === 'smile') {
                document.getElementsByClassName('eye')[0].style.animation = ''
                document.getElementsByClassName('eye')[1].style.animation = ''
                document.getElementsByClassName(
                    'eyes'
                )[0].style.animationPlayState = 'running'
                document.getElementsByClassName(
                    'mouth'
                )[0].style.animationPlayState = 'running'
                document.getElementsByClassName('mouth')[0].style.height = '30%'
                document.getElementsByClassName('mouth')[0].style.width = '60%'
                document.getElementsByClassName('mouth')[0].style.bottom = '18%'
                document.getElementsByClassName('mouth')[0].style.marginLeft =
                    '-30%'
            }

            document.getElementsByClassName(
                this.animMapping[name]
            )[0].style.display = this.animMapping[visibility]
        },
        // End of onSubmit() method
        onVideoRecording() {
            this.toggleAnimation('layer1', 0)
            this.setFontColor('layer1', '#3E3E3E')

            const sound =
                'data:audio/mpeg;base64,SUQzBAAAAAABEVRYWFgAAAAtAAADY29tbWVudABCaWdTb3VuZEJhbmsuY29tIC8gTGFTb25vdGhlcXVlLm9yZwBURU5DAAAAHQAAA1N3aXRjaCBQbHVzIMKpIE5DSCBTb2Z0d2FyZQBUSVQyAAAABgAAAzIyMzUAVFNTRQAAAA8AAANMYXZmNTcuODMuMTAwAAAAAAAAAAAAAAD/80DEAAAAA0gAAAAATEFNRTMuMTAwVVVVVVVVVVVVVUxBTUUzLjEwMFVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVf/zQsRbAAADSAAAAABVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVf/zQMSkAAADSAAAAABVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVV'
            this.soundeffect.src = sound

            console.log('video recording function called')
            this.$socket.client.emit('start_recording')
            this.$socket.client.on('start_recording_client', (data) => {
                this.$socket.client.off('start_recording_client')

                if (data['status'] === true) {
                    console.log(
                        'start_recording_client returned from server: ',
                        data
                    )
                    this.activeQuestion = data['question']
                    this.previousQuestion = ''
                    this.setLabel(this.activeQuestion)
                    this.toggleAnimation('layer1', 1)
                    this.toggleAnimation('face_outline', 0)
                    this.toggleAnimation(this.activeQuestion, 1)
                    this.playAudio(this.activeQuestion)
                    this.recordingStart = true
                    this.timeShow = true
                    this.showVideo = false
                    this.countDown = 20
                    this.frameCountServer = this.frameCount
                    this.countDownTimer()
                    this.frameCapture()
                }
            })
        },

        drawLivenessPassed() {
            const thumbnail = this.$root.$refs.B.getThumbnail()
            document.getElementById('anim_layer').style.visibility = 'hidden'
            document.getElementById('video-play').style.visibility = 'hidden'
            let width = document.getElementById('container_row').clientWidth
            let height = document.getElementById('container_row').clientHeight
            document.getElementById('thumbnail_img').width = width
            document.getElementById('thumbnail_img').height = height
            document.getElementById('thumbnail_img').style.zIndex = '3'
            document.getElementById('thumbnail_img').src = thumbnail
        },
        async onRecordingEnded(player) {
            console.log(
                'onRecordingEnded CALLED: Liveness = ',
                this.livenessStatus
            )
            this.recordingStart = false
            this.recordingEnded = true
            this.toggleAnimation(this.activeQuestion, 0)
            this.$socket.client.emit('end_recording')

            if (this.livenessStatus) {
                this.showVideo = true
                this.timeShow = false
                this.$root.$refs.B.closeCamera()
                this.drawLivenessPassed()
                this.countDown = 0

                try {
                    const formData = new FormData()
                    formData.append('type', 'video')
                    formData.append('file', player.recordedData, 'video.mp4')
                    const headers = {
                        'Content-Type': 'multipart/form-data',
                    }
                    const { data } = await request.post('files/', formData, {
                        headers,
                    })
                    this.$store.commit('updateField', {
                        key: 'documentInfo.video.fileName',
                        value: data.data.fileName,
                    })
                } catch (error) {
                    console.log(error)
                }
            } else {
                this.showVideo = false
                this.timeShow = false
                document.getElementById('record-label').innerHTML = 'retry'
                this.setLabel('LIVENESS FAILED')
                this.setFontColor('layer1', '#D34934')
                this.toggleAnimation('layer1', 1)
                this.playAudio('failed')
                // this.toggleAnimation('face_outline', 2);
            }
        },
        countDownTimer() {
            if (this.countDown > 0 && this.recordingStart === true) {
                setTimeout(() => {
                    this.countDown -= 1
                    console.log(
                        'CountDown VALUE: ',
                        this.countDown,
                        ', RecordingStart: ',
                        this.recordingStart
                    )
                    this.countDownTimer()
                }, 1000)
            } else {
                console.log(
                    'CountDown VALUE @ False: ',
                    this.countDown,
                    ', RecordingStart @ False: ',
                    this.recordingStart
                )
            }
        },

        getQuestion(frameCount) {
            console.log('Active question called')
            this.toggleAnimation('layer1', 0)
            this.toggleAnimation(this.activeQuestion, 0)

            this.$socket.client.emit('get_question', this.activeQuestion)
            this.$socket.client.on('question_fetch', (question) => {
                this.$socket.client.off('question_fetch')

                if (
                    this.recordingStart === true &&
                    this.livenessStatus === false
                ) {
                    console.log('New Active Question: ', question)
                    this.previousQuestion = this.activeQuestion
                    this.activeQuestion = question
                    this.setFontColor('layer1', '#3E3E3E')
                    this.setLabel(this.activeQuestion)
                    this.toggleAnimation('layer1', 1)
                    this.playAudio(this.activeQuestion)
                    setTimeout(
                        this.toggleAnimation,
                        200,
                        this.activeQuestion,
                        1
                    )
                    setTimeout(() => {
                        this.frameCountServer = frameCount
                    }, 1000)
                }
            })
        },
        frameCapture() {
            if (this.timeShow === true) {
                setTimeout(() => {
                    // console.log(
                    //     'recording in progress ... capturing frames: ',
                    //     this.countDown
                    // )
                    this.print()
                    this.frameCapture()
                }, 500)
            }
        },

        async print() {
            if (
                this.frameCount === this.frameCountServer &&
                this.livenessStatus === false
            ) {
                this.frameCount += 1

                let stime = new Date()
                console.log(
                    'Active Question outside: ',
                    this.activeQuestion,
                    ', Frame Count: ',
                    this.frameCount
                )

                // let heights = this.videoCam.videoHeight;
                // let widths = this.videoCam.videoWidth;
                // let AR = (widths/heights);
                //
                // let rs = this.videoCam.readyState;

                // console.log('Camera Height ->>> ', heights);
                // console.log('Camera Width ->>> ', widths);
                // console.log('Camera state ->>> ', rs);
                // console.log('Aspect Ratio ->>> ', (widths/heights));
                // (document.getElementById('frame-canvas')).width = widths;
                // (document.getElementById('frame-canvas')).height = heights;

                let c = 0
                this.getImage(stime, c)
            }
        },

        getImage(stime, c) {
            if (this.recordingStart === false) {
                return
            }
            c += 1
            // const type = "image/jpeg";
            // let context = this.$refs.canvas.getContext("2d");
            // context.drawImage(video, 0, 0, 320, 420);
            // const canvas = document
            //   .getElementById("frame-canvas")
            //   .toDataURL(type)
            //   .replace("data:" + type + ";base64,", "");

            let frame = this.$root.$refs.B.sendFrame()
            console.log('SIZE AT FRONT: ', frame.length)
            // context.drawImage(this.videoCam, 0, 0, this.videoCam.videoWidth, this.videoCam.videoHeight);

            if (frame.length < 5000) {
                setTimeout(() => {
                    this.getImage(stime, c)
                }, 100)
            } else {
                console.log('Times image taken: ', c)
                this.uploadData(frame, stime)
            }
        },
        uploadData(imageData, stime) {
            let image_size = new TextEncoder().encode(imageData).length
            console.log('Image size: ', image_size, imageData.length)
            let time_sent = Date.now()
            let capture_lag = time_sent - stime
            let client_frame_lag = time_sent - this.frameLag
            console.log('capture lag-> : ', capture_lag, ' ms')
            let data = {
                count: this.frameCount,
                time: time_sent,
                active_question: this.activeQuestion,
                data: imageData,
            }
            this.$socket.client.emit('upload_data', data)
            this.$socket.client.on('liveness_result', (data_server) => {
                this.$socket.client.off('liveness_result')
                let time_received = Date.now()
                let prev_lag = time_received - this.frameLag
                this.frameLag = time_received
                let total_lag = time_received - data_server['time']
                let receive_lag = time_received - data_server['time_received']
                console.log(
                    'Received Count:',
                    data_server['count'],
                    ', active_question:',
                    data_server['active_question'],
                    ', Result:',
                    data_server['result'],
                    ', Total Lag:',
                    total_lag,
                    'ms',
                    ', Capture Lag:',
                    capture_lag,
                    'ms',
                    ', Client_frame_lag:',
                    client_frame_lag,
                    'ms',
                    ', Previous Frame Lag:',
                    prev_lag,
                    'ms',
                    ', Upload Lag:',
                    data_server['upload_lag'],
                    'ms',
                    ', Process Lag:',
                    data_server['process_lag'],
                    'ms',
                    ', Receive Lag:',
                    receive_lag,
                    'ms',
                    ', Image Read Status:',
                    data_server['img_read']
                )
                if (this.recordingStart) {
                    if (data_server['liveness_result'] === true) {
                        this.livenessStatus = true
                        this.$root.$refs.B.setLiveness(true)
                        // this.frameCountServer = data_server['count']
                        this.toggleAnimation(this.activeQuestion, 0)
                        this.setFontColor('layer1', 'green')
                        this.setLabel('LIVENESS PASSED')
                        this.playAudio('passed')
                      this.onRecordingEnded(this.$refs.camera1)
                    } else if (data_server['result'] === true) {
                        this.questionTransition(data_server['count'])
                        //this.frameCountServer = data_server['count']
                    } else {
                        this.frameCountServer = data_server['count']
                    }
                }
            })
        },

        questionTransition(count) {
            this.setFontColor('layer1', 'green')
            this.playAudio('correct')
            setTimeout(() => {
                if (
                    this.recordingStart === true &&
                    this.livenessStatus === false
                ) {
                    this.getQuestion(count)
                }
            }, 1000)
        },
        setFontColor(id, color) {
            document.getElementsByClassName(id)[0].style.color = color
        },
        showMsgBoxTwo() {
            this.$bvModal
                .msgBoxOk(
                    'Please remove glasses if wearing to get better results',
                    {
                        title: 'Alert',
                        size: 'sm',
                        buttonSize: 'sm',
                        okVariant: 'success',
                        headerClass: 'p-2 border-bottom-0',
                        footerClass: 'p-2 border-top-0',
                        centered: true,
                    }
                )
                .then((value) => {
                    // On Ok
                    console.log('pop-up', value)
                })
                .catch((err) => {
                    // An error occurred
                    console.log('pop-up error', err)
                })
        },
    }, // End of Component > mounted
} // End of export default

// setInterval(() => {
//
//   if (this.timeShow === true){
//         console.log('Recording video ... ')
//     }
// }, 1000)
</script>
<style>
.container_row {
    display: grid;
}

.show-record-video,
.layer2,
.layer1,
.arrow,
.smiley,
.frame-canvas-c,
.cam_error,
.cam_error_phone,
.thumbnail_img {
    grid-column: 1;
    grid-row: 1;
}

.cam_error,
.cam_error_phone,
.thumbnail_canvas {
    display: none;
    /*visibility: hidden;*/
    z-index: 5;
    /*max-width:100%;*/
    /*max-height: 100%;*/
}
.show-record-video span {
    z-index: 1;
}

.layer2 {
    user-select: none;
    position: absolute;
    display: flex;
    justify-content: center;
    align-items: center;
    z-index: 3;
}

.layer1 {
    /*background: transparent;*/
    /*background: rgba(200, 54, 54, 0.2);*/
    text-align: center;
    user-select: none;
    font-family: 'liveness';
    text-transform: uppercase;
    color: #3e3e3e;
    font-size: 175%;
    z-index: 3;
    margin-top: 5%;
    -webkit-font-smoothing: antialiased;
    -webkit-backface-visibility: hidden;
    -webkit-transform: translate3d(0, 0, 0);
    /*animation: color-change 2s infinite;*/
}

.arrow {
    position: absolute;
    user-select: none;
    /*visibility: hidden;*/
    display: none;
    top: 50%;
    left: 80%;
    transform: rotate(-90deg);
    z-index: 4;
}

.arrow span {
    display: block;
    width: 30px;
    height: 30px;
    /*border-bottom: 5px solid  rgba(163, 26, 255, 0.8);*/
    /*border-right: 5px solid  rgba(163, 26, 255, 0.8);*/
    border-bottom: 5px solid rgba(251, 192, 0, 0.8);
    border-right: 5px solid rgba(251, 192, 0, 0.8);
    margin: -10px;
    animation: animate-arrow 2s infinite;
}
.arrow span:nth-child(2) {
    animation-delay: -0.2s;
}
.arrow span:nth-child(3) {
    animation-delay: -0.4s;
}
@keyframes animate-arrow {
    0% {
        opacity: 0;
        transform: rotate(45deg) translate(-20px, -20px);
    }
    50% {
        opacity: 1;
    }
    100% {
        opacity: 0;
        transform: rotate(45deg) translate(20px, 20px);
    }
}

@keyframes color-change {
    0% {
        color: #3e3e3e;
    }
    50% {
        color: #534660;
    }
    100% {
        color: #3e3e3e;
    }
}
/*top: 80%;*/

.smiley {
    background: linear-gradient(
        135deg,
        rgb(255, 233, 25) 0%,
        rgb(251, 192, 0) 100%
    );
    border-radius: 100%;
    user-select: none;
    /*padding: 25px;*/
    position: absolute;
    /*visibility: hidden;*/
    display: none;
    font-family: 'Open Sans', sans-serif;
    text-align: center;
    width: 100px;
    height: 100px;
    left: 85%;
    top: 85%;
    z-index: 4;
    opacity: 0.7;
    transform: translateX(-50%) translateY(calc(-50% - 121px));
    box-shadow: rgba(211, 165, 110, 0.4) 0px 30px 30px 1px,
        rgba(245, 245, 245, 0.1) 0px 20px 10px 1px;
}

.mouth {
    width: 60%;
    height: 30%;
    border-top-left-radius: 0;
    border-top-right-radius: 0;
    border-bottom-left-radius: 100px;
    border-bottom-right-radius: 100px;
    box-sizing: border-box;
    position: absolute;
    bottom: 18%;
    left: 50%;
    margin-left: -30%;
    background: #b57700;
    transition: all 300ms cubic-bezier(0.645, 0.045, 0.355, 1);
    animation: move-mouth-normal 2s infinite;
}
.eyes {
    width: 100%;
    margin-top: 15%;
    box-sizing: border-box;
    padding: 0 20px;
    transition: all 300ms cubic-bezier(0.645, 0.045, 0.355, 1);
    animation: move-eyes-down 2s infinite;
}
.eyes .eye {
    width: 13px;
    height: 13px;
    background: #b57700;
    float: left;
    border-radius: 100%;
    position: relative;
}
.eyes .eye:nth-of-type(2) {
    float: right;
}
@keyframes move-mouth-normal {
    0% {
        border-top-left-radius: 100px;
        border-top-right-radius: 100px;
        border-bottom-left-radius: 100px;
        border-bottom-right-radius: 100px;
        height: 5%;
        width: 40%;
        bottom: 25%;
        margin-left: -20%;
    }
}

@keyframes wink {
    0% {
        height: 20px;
        margin-top: 0;
    }

    3.9% {
        height: 3px;
        margin-top: 8px;
    }

    9.1% {
        height: 3px;
        margin-top: 8px;
    }

    13% {
        height: 20px;
        margin-top: 0;
    }

    100% {
        height: 20px;
        margin-top: 0;
    }
}

@keyframes move-eyes-down {
    0% {
        margin-top: 27%;
    }

    10.55% {
        margin-top: 31%;
    }

    18.45% {
        margin-top: 31%;
    }

    30% {
        margin-top: 27%;
    }

    100% {
        margin-top: 27%;
    }
}

*,
*::before,
*::after {
    margin: 0;
    padding: 0;
    box-sizing: border-box;
}

p {
    color: #2e2e2e;
    margin-bottom: 20px;
}

/* block-$ */
.block-effect {
    font-size: calc(6px + 3vw);
    background-color: white;
}

.block-reveal {
    --t: calc(var(--td) + var(--d));

    color: transparent;
    padding: 4px;

    position: relative;
    overflow: hidden;

    animation: revealBlock 0s var(--t) forwards;
}

.block-reveal::after {
    content: '';

    width: 0%;
    height: 100%;
    padding-bottom: 4px;

    position: absolute;
    top: 0;
    left: 0;

    background: var(--bc);
    animation: revealingIn var(--td) var(--d) forwards,
        revealingOut var(--td) var(--t) forwards;
}

#frame-canvas {
    display: none;
    /*position: absolute;*/
    z-index: 4;
}

#video2 {
    display: none;
}
#intro_anim {
    position: absolute;

    top: 30%;
    right: 22%;
    left: 28%;
    margin: 0px auto;

    /*z-index:3;*/
    -webkit-animation: cssAnimation 6s forwards;
    animation: cssAnimation 6s forwards;
}

/* animations */
@keyframes cssAnimation {
    0% {
        opacity: 1;
    }
    90% {
        opacity: 1;
    }
    100% {
        opacity: 0;
    }
}
@-webkit-keyframes cssAnimation {
    0% {
        opacity: 1;
    }
    90% {
        opacity: 1;
    }
    100% {
        opacity: 0;
    }
}

@keyframes revealBlock {
    100% {
        color: #0f0f0f;
    }
}

@keyframes revealingIn {
    0% {
        width: 0;
    }

    100% {
        width: 100%;
    }
}

@keyframes revealingOut {
    0% {
        transform: translateX(0);
    }

    60% {
        opacity: 1;
    }
    100% {
        opacity: 0;
        transform: translateX(100%);
    }
}
  .video-recorded
  {
    z-index: 9999 !important;
  }
</style>
